import React from "react";
import "./styles.css";
import { Input } from "../../components/common/Input";
import { Button } from "../../components/common/Button";
import { Link } from "react-router-dom";
import { UserActionCreator } from "../../store/userActions";
import { RootState } from "../../store";
import { connect } from "react-redux";
import {
  selectIsRememberMe,
  selectUserError,
  selectUserPending,
} from "../../store/selectors";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { REGEXES } from "../../constants/common";
import { Switcher } from "../../components/common/Switcher";
import { InfoBar } from "../../components/common/InfoBar";
import {
  ANALYTICS_EVENTS,
  trackAnalyticsEvent,
} from "../../analytics";

export const _SignIn = ({
  pending,
  error,
  signInRequest,
  rememberMe,
  setRememberMe,
}) => {
  const [, setCookie] = useCookies();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const emailError = errors.email?.message;
  const passwordError = errors.password?.message;
  const maxAge = rememberMe ? 60 * 60 * 24 * 365 : undefined;

  const onSubmit = async (data) => {
    const action = await signInRequest(data);
    const newToken = action?.payload?.data?.token;

    if (!newToken) return;

    setCookie("userToken", newToken, { path: "/", maxAge });
    if (rememberMe) {
      setCookie("rememberMe", rememberMe, { path: "/", maxAge });
    }
    trackAnalyticsEvent(ANALYTICS_EVENTS.AUTH_SIGN_IN_SUCCEEDED, {
      remember_me: Boolean(rememberMe),
    });
  };
  return (
    <>
      <div className="sign-in_container">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="sign-up_form-container"
        >
          <div className="sign-in_input-item">
            <Input
              register={register("email", {
                required: { message: "введите e-mail", value: true },
                pattern: {
                  message: "некорректный e-mail",
                  value: REGEXES.email,
                },
              })}
              name="areaWorth"
              type="email"
              placeholder="e-mail"
              label="введите e-mail"
              error={!!emailError}
              errorMessage={emailError}
            />
          </div>
          <div className="sign-in_input-item">
            <Input
              register={register("password", {
                required: { message: "введите пароль", value: true },
                pattern: {
                  message: "некорректный пароль",
                  value: REGEXES.password,
                },
              })}
              name="areaWorth"
              type="password"
              placeholder="пароль"
              label="введите пароль"
              error={!!passwordError}
              errorMessage={passwordError}
            />
          </div>
          {error && (
              <InfoBar
                  className="sign-in_error"
                  type="error"
                  text="Не удалось авторизоваться. Проверьте правильность введенных данных"
              />
          )}
          <Link className="sign-in_link" to="/reset-password/">
            Забыли пароль?
          </Link>
          <div className="sign-in_input-item">
            <Switcher
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              label="запомнить меня"
            />
          </div>
          <div className="sign-in_input-item">
            <Button pending={pending} text="войти" fullWidth />
          </div>
        </form>
        <div className="sign-in_reg-advice">
          Нет аккаунта?{" "}
          <Link className="sign-in_link" to="/signup/">
            Регистрация
          </Link>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  pending: selectUserPending(state),
  error: selectUserError(state),
  rememberMe: selectIsRememberMe(state),
});

const mapDispatchToProps = {
  signInRequest: UserActionCreator.userSignIn,
  setRememberMe: UserActionCreator.setRememberMe,
};

export const SignIn = connect(mapStateToProps, mapDispatchToProps)(_SignIn);
